<div class="search-tags-list">
  <div class="search-tags">
    <h3 class="mb-3">{{ 'TRENDS' | translate }}</h3>
    <p>
      <span *ngFor="let k of keywords" (click)="searchKeywords(k.name, $event)">#{{ k.name }}</span>
    </p>
  </div>
</div>
